
//import errorHandler from './errorHandler'
import api from '../../../api'
import apiAsync from '../../../api/async'
import _ from 'lodash'
import qs from 'query-string'
import messages from '../../../store/messages';
import accounts from '../../../store/accounts';
import networks from '../../../store/networks';
import func from '../../functions';

/* class Messages {

    static get(payload){
        console.log('#', payload)
    }

}

export default Messages; */

 export default {
    create : (payload, next) => {
        api.post('/api/v1/messages', payload.body,(err, data) => {
            if(err) return next(err, null);

            next(null, data);

        })   
    },
    get : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.get('/api/v1/conversations' + queryString, (err, data) => {
            if(err) return next(err, null);

            next(null, data);

        })   
    },
    getVersion3 : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.getHeadersIncluded('/api/v1/conversations/'+ payload.version + queryString, (err, data) => {
            if(err) return next(err, null);

            next(null, data.data, data);

        })   
    },
    getAsync : async (payload) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        return await apiAsync.get('/api/v1/conversations' + queryString);   
    },
    getMessages : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.get('/api/v1/messages' + queryString, (err, data) => {
            if(err) return next(err, null);

            next(null, data);

        })   
    },
    count : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.head('/api/v1/conversations' + queryString, (err, data) => {
            if(err) return next(err, null);

            next(null, data);

        })   

    },
    search : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.get('/api/v1/messages' + queryString, (err, data) => {
            if(err) return next(err, null);

            next(null, data);

        })   

    },
    update : (payload, next) => {
        api.put('/api/v1/messages', payload.body, (err, data) => {
            if(err) return next(err, null);

            next(null, data);

        })   

    },
    getCsv : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        let header = { 'Accept': 'text/csv' }
        api.get('/api/v1/messages' + queryString, (err, data) => {
            if(err) return next(err, null);

            next(null, data);

        }, header)   

    },
    helper: (data, order) => {
            
        let orderedConversations = [];
        if(order){
            orderedConversations = _.orderBy(data, [function(conversation){ 
                return _.get(conversation, 'reply.createdAt' , conversation.createdAt);
            }], ['asc'])
        }else{
            //console.log(order)
            orderedConversations = _.orderBy(data, [function(conversation){ 
                return _.get(conversation, 'reply.createdAt' , conversation.createdAt);
            }], ['desc'])
        }

          let filteredCheckByFrom = _.filter(orderedConversations, conversation => _.has(conversation, 'from.name') || _.has(conversation, 'from.nick'))

          const manipulationLoop = _.map(filteredCheckByFrom, conversation => {

        //    console.log(conversation.platform);

            if(networks.state.networksById[conversation.platform].name == "Instagram"){
                if (conversation.from && !conversation.from.name) conversation.from.name = conversation.from.nick;
                if (conversation.from && !conversation.from.avatar) conversation.from.avatar = '/img/avatar/roboto/128/latin_'+ func.turkishToEnglish(conversation.from.name).charAt(0).toLowerCase() + '.png';
    
                if (conversation.reply && conversation.reply.from && !conversation.reply.from.name) conversation.reply.from.name = conversation.reply.from.nick
    
                if(conversation.reply && conversation.reply.from && !conversation.reply.from.id) conversation.reply.from.id = conversation.reply.from.nick;
    
                if(conversation.reply && conversation.reply.from && !conversation.from.id) conversation.from.id = conversation.from.nick;
            }

            return conversation;
        });

/*         const filterOwnMessagesWithoutReply = _.filter(manipulationLoop, (e) => {
            if(e.lastReply || !accounts.state.accountsByPId[e.from.id]){
              return e;
            }
          }); */

        return manipulationLoop
    }
} 
 


// WEBPACK FOOTER //
// ./src/libs/system/services/messages.js